import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import CreateGroupModal from './CreateGroupModal';
import {
  createGroupClear,
  createGroupInitiate,
  getGroupDetailsInitiate,
  setUploadMsg,
  addEmployeeTopupCycleInitiate,
  confirmGroupInitiate,
  addEmployeeTopupCycleClear,
} from '../../../../actions/groups';
import { openErrorToast } from '../../../../reducers/uiLogic';
import { currentFlowTypeEnum, groupUploadMsg } from '../constants';

const mapStateToProps = state => {
  const groupData = _get(state, 'groups.groupData', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const createGroupDetails = _get(state, 'groups.confirmGroup', {});
  const mappedOffices = _get(state, 'company.mappedOffices', {});
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  const companyData = _get(state, 'company', {});
  return {
    currentFlow,
    groupData,
    companyData,
    mappedOffices,
    selectedWorkspace,
    createGroupDetails,
    uploadMsg: _get(state, 'groups.uploadMsg', groupUploadMsg),
    creatingGroup:
      _get(state, 'apiState.CREATE_GROUP.isFetching', false) &&
      !_get(state, 'apiState.CREATE_GROUP.isIdle', false),
    groupCreated:
      _get(state, 'apiState.CREATE_GROUP.success', false) &&
      !_get(state, 'apiState.CREATE_GROUP.isIdle', false),
    fetchingGroupDetails:
      _get(state, 'apiState.GET_GROUP_DETAILS.isFetching', true) &&
      !_get(state, 'apiState.GET_GROUP_DETAILS.isIdle', false),
    processId: _get(state, 'groups.processId', ''),
    confirmingGroup:
      _get(state, 'apiState.CONFIRM_GROUP.isFetching', false) &&
      !_get(state, 'apiState.CONFIRM_GROUP.isIdle', false),
    confirmCreationGroup:
      _get(state, 'apiState.CONFIRM_GROUP.success', false) &&
      !_get(state, 'apiState.CONFIRM_GROUP.isIdle', false),
    confirmAddEmlpoyeeTopupCycle:
      _get(state, 'apiState.SET_ADD_EMPLOYEE_TOPUP_CYCLE.success', false) &&
      !_get(state, 'apiState.SET_ADD_EMPLOYEE_TOPUP_CYCLE.isIdle', false),
  };
};

const mapDispatchToProps = dispatch => ({
  clearCreateGroup: () => dispatch(createGroupClear()),
  getGroupDetails: payload => dispatch(getGroupDetailsInitiate(payload)),
  setFileUploadMsg: message => dispatch(setUploadMsg(message)),
  createGroup: payload => dispatch(createGroupInitiate(payload)),
  showErrorToast: message => dispatch(openErrorToast(message)),
  confirmGroup: payload => dispatch(confirmGroupInitiate(payload)),
  setAddEmployeeTopupCycle: payload =>
    dispatch(addEmployeeTopupCycleInitiate(payload)),
  clearAddEmployeeTopupCycle: () => dispatch(addEmployeeTopupCycleClear()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateGroupModal);
